import { db } from "../firebase/config";
import { collection, doc, addDoc, updateDoc, deleteDoc, onSnapshot } from "firebase/firestore";

export function subscribeToZones(callback) {
  return onSnapshot(collection(db, "warehouse_zones"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    // Sort alphabetically by name
    list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to zones:", error);
    callback([], error);
  });
}

export async function seedZonesIfEmpty(zones) {
  if (zones.length > 0) return;

  const defaultZones = ["Receiving Dock", "Aisle 1", "Aisle 2", "Cold Storage", "Bulk Storage", "Shipping Dock"];

  for (const zone of defaultZones) {
    try {
      await addDoc(collection(db, "warehouse_zones"), { name: zone });
    } catch(e) {
      console.error(e);
    }
  }
}

export async function addZone(zoneData) {
  const docRef = await addDoc(collection(db, "warehouse_zones"), zoneData);
  return docRef.id;
}

export async function updateZone(id, zoneData) {
  const docRef = doc(db, "warehouse_zones", id);
  await updateDoc(docRef, zoneData);
}

export async function deleteZone(id) {
  const docRef = doc(db, "warehouse_zones", id);
  await deleteDoc(docRef);
}
